<div class="store-detail">
  @if (isOpeningSoon()) {
    <span class="opening-soon">OUVERTURE PROCHAINE</span>
  }
  <div class="header">
    <app-title [titles]="[title()]" />
    @if (store().distance !== null) {
      <span class="distance">{{ store().distance! }} km</span>
    }
  </div>
  <a [href]="googleMapsUrl()" class="address" target="_blank">{{ store().address }}</a>
  <a class="phone" href="tel:{{ store().phone }}" target="">{{ store().phone }}</a>
  @let _statusIndicator = statusIndicator();
  @if (_statusIndicator) {
    <div class="operational-status operational-status--{{ _statusIndicator.modifier }}">
      <span class="operational-status__dot"></span>
      <span class="operational-status__message">{{ _statusIndicator.message }}</span>
    </div>
  }
  <span class="opening">{{ store().opening }}</span>
  <div class="actions">
    <app-button
      [icon]="{ name: 'CALENDAR', color: 'WHITE', size: '2rem' }"
      [params]="{
        store: store().uuid,
        label: store().name,
        isHomeAppointment: store().isHomeAppointment,
        phone: store().phone,
      }"
      [style]="{ width: '100%' }"
      [url]="urlAppointment() ?? ''"
      class="button"
      label="Prendre rendez-vous"
      theme="BLUE" />

    <app-button
      [icon]="{ name: 'CHEVRON_RIGHT', color: 'BLACK', size: '2rem' }"
      [style]="{ width: '100%' }"
      [url]="store().url"
      class="button"
      label="Découvrir la boutique" />
  </div>
</div>
